module.exports = __webpack_public_path__ + "static/img/zanwu_pc.3ec44969.jpg";